import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from "react-router";

const PrivateRouter = ({ children}) => {
  const currentUser = useSelector((state) => state.auth);
  //console.log(currentUser);
  return currentUser.isLoggedIn ? children : <Navigate to="/login" />;
}

export default PrivateRouter